import apiClient from './client';

export const contentAPI = {
  getAll: (params) => apiClient.get('/content', { params }),
  getOne: (id) => apiClient.get(`/content/${id}`),
  create: (data) => apiClient.post('/content', data),
  update: (id, data) => apiClient.put(`/content/${id}`, data),
  setPayment: (id, data) => apiClient.patch(`/content/${id}/payment`, data),
  delete: (id) => apiClient.delete(`/content/${id}`),
  addSegment: (contentId, data) => apiClient.post(`/content/${contentId}/segments`, data),
  updateSegment: (contentId, segmentId, data) => apiClient.put(`/content/${contentId}/segments/${segmentId}`, data),
  deleteSegment: (contentId, segmentId) => apiClient.delete(`/content/${contentId}/segments/${segmentId}`),
  // Rejected-content review queue
  getRejected: (params) => apiClient.get('/content/rejected/list', { params }),
  closeRejected: (id) => apiClient.post(`/content/rejected/${id}/close`),
  // Instagram Graph API (App Review demo)
  instagramConnected: (params) => apiClient.get('/content/instagram/connected', { params }),
  instagramLookup: (username, params) => apiClient.get('/content/instagram/graph-preview', { params: { username, ...params } }),
  instagramPullCampaign: (campaignId) => apiClient.post(`/content/instagram/pull-campaign/${campaignId}`),
};
